import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

/* Clone slides until Swiper has enough DOM nodes for seamless loop mode. */
function prepareSlidesForLoop(carousel) {
	const minimumSlidesForLoop = 4;
	const slides = [...carousel.children].filter(node => node.classList.contains('swiper-slide'));
	const originalCount = slides.length;

	if (originalCount === 0 || originalCount >= minimumSlidesForLoop) {
		return originalCount;
	}

	const targetCount = Math.max(minimumSlidesForLoop, originalCount * 2);
	let cloneIndex = 0;
	while (slides.length + cloneIndex < targetCount) {
		carousel.append(slides[cloneIndex % originalCount].cloneNode(true));
		cloneIndex++;
	}

	return originalCount;
}

/*
 * Find the slide closest to the current position whose
 * data-swiper-slide-index maps back to the given original.
 */
function findClosestSlide(swiper, targetOriginal, originalCount) {
	let closestIndex = -1;
	let closestDistance = Number.POSITIVE_INFINITY;

	for (const [i, slide] of swiper.slides.entries()) {
		const swiperIndex = Number.parseInt(slide.dataset.swiperSlideIndex, 10);
		if (swiperIndex % originalCount === targetOriginal) {
			const distance = Math.abs(i - swiper.activeIndex);
			if (distance < closestDistance) {
				closestDistance = distance;
				closestIndex = i;
			}
		}
	}

	return closestIndex;
}

document.addEventListener('DOMContentLoaded', () => {
	for (const carousel of document.querySelectorAll('.swiper.quotes')) {
		const isReviewsBlock = carousel.classList.contains('gs-reviews');
		if (isReviewsBlock && carousel.querySelectorAll(':scope > .swiper-slide').length < 2) {
			carousel.classList.add('gs-reviews-single');
			continue;
		}

		const originalCount = prepareSlidesForLoop(carousel);
		if (originalCount === 0) {
			continue;
		}

		new Swiper(carousel, {
			modules: [Navigation, Pagination, Autoplay],
			slidesPerView: 'auto',
			spaceBetween: 32,
			/*
			 * Existing quote carousels inset the first slide by 64px. Doing that
			 * again on update pushes a Reviews slide an extra 64px right, so its
			 * right edge meets the clip. Centering the same width keeps both edges in.
			 */
			slidesOffsetBefore: isReviewsBlock ? 0 : 64,
			centeredSlides: isReviewsBlock,
			loop: true,
			speed: 1000,
			grabCursor: true,
			createElements: true,

			pagination: {
				enabled: true,
				clickable: true,
				renderBullet(index, className) {
					if (index >= originalCount) {
						return `<span class="${className}" style="display:none"></span>`;
					}

					return `<span class="${className}"></span>`;
				},
			},
			navigation: true,

			autoplay: {
				delay: 8000,
				pauseOnMouseEnter: true,
			},

			on: {
				/*
				 * Override Swiper's built-in bullet click (which always targets the
				 * original slide via slideToLoop) so we navigate to whichever copy
				 * — original or clone — is closest to the current position.
				 */
				paginationRender(swiper, paginationElement) {
					const bullets = [...paginationElement.querySelectorAll('.swiper-pagination-bullet')];
					for (const [i, bullet] of bullets.entries()) {
						if (i >= originalCount) {
							break;
						}

						bullet.addEventListener('click', event => {
							event.stopPropagation();

							if (swiper.realIndex % originalCount === i) {
								return;
							}

							const closest = findClosestSlide(swiper, i, originalCount);
							if (closest >= 0) {
								swiper.slideTo(closest);
							}
						});
					}
				},

				paginationUpdate(swiper) {
					const corrected = swiper.realIndex % originalCount;
					for (const [i, bullet] of swiper.pagination.bullets.entries()) {
						bullet.classList.toggle('swiper-pagination-bullet-active', i === corrected);
					}
				},
			},
		});
	}
});
